export default __webpack_public_path__ + "static/media/Raining_03.46769603.png";